export default (function (siteVars) {
  return {
    borderColorHover: siteVars.accessibleCyan,
    disabledToggleIndicatorColor: siteVars.accessibleGreen
  };
});
//# sourceMappingURL=checkboxVariables.js.map
